import React from 'react';

import { IconMoreHoriz } from './icons/Icons';

export default function EllipseButton() {
    return (
        <li className="rec-pagination-ellipse">
            <IconMoreHoriz alt="More" />
        </li>
    );
}
